export const mockData = [
    {
        id: '9128',
        name: 'Lake District and many more other lovely places in the world',
        link: 'england/lake-district',
    },
    {
        id: '10135',
        name: 'Blackdown Hills',
        link: 'england/blackdown-hills',
        subtitle: 'Black down subtitle',
    },
    {
        id: '22423',
        name: 'Channel Islands',
        link: 'channel-islands',
    },
    {
        id: '21667',
        name: 'England',
        link: 'england',
    },
    {
        id: '10275',
        name: 'Forest of Bowland',
        link: 'england/forest-of-bowland',
        subname: 'subname example',
    },
    {
        id: '10095',
        name: 'Llyn Peninsula',
        link: 'wales/llyn-peninsula',
    },
    {
        id: '10129',
        name: 'Northumberland Coast',
        link: 'england/northumberland-coast',
    },
    {
        id: '9132',
        name: 'Northumberland National Park',
        link: 'england/northumberland-national-park',
    },
    {
        id: '1429',
        name: 'Scotland',
        link: 'scotland',
    },
    {
        id: '21668',
        name: 'Southern England',
        link: 'england/southern-england',
    },
    {
        id: '21907',
        name: 'Cambridgeshire',
        link: 'england/east-anglia/cambridgeshire',
    },
    { id: '21673', name: 'Canterbury', link: 'england/kent/canterbury' },
    { id: '10094', name: 'Cardigan Bay', link: 'wales/cardigan-bay' },
    {
        id: '22226',
        name: 'Cardigan/Ceredigion',
        link: 'wales/mid-wales/cardiganceredigion',
    },
    {
        id: '22239',
        name: 'Carmarthenshire',
        link: 'wales/south-wales/carmarthenshire',
    },
    {
        id: '21682',
        name: 'Castle Combe',
        link: 'england/wiltshire/castle-combe',
    },
    {
        id: '21958',
        name: 'Lancashire ',
        link: 'england/north-west-england/lancashire',
    },
    {
        id: '21751',
        name: 'Newcastle Upon Tyne',
        link: 'england/northumberland/newcastle-upon-tyne',
    },
    {
        name: 'Lake View Lodges - No. 1 Lake View Lodge',
        subtitle: '25072, Old Leake, near Boston, Lincolnshire',
        link: 'cottages/lake-view-lodges-no-1-lake-view-lodge-25072',
        id: '25072',
        property: true,
    },
    {
        name: 'Lake View Lodges - No. 2 Lake View Lodge',
        subtitle: '25073, Old Leake, near Boston, Lincolnshire',
        link: 'cottages/lake-view-lodges-no-2-lake-view-lodge-25073',
        id: '25073',
        property: true,
    },
    {
        name: 'Lake View Lodges - No. 3 Lake View Lodge',
        subtitle: '25074, Old Leake, near Boston, Lincolnshire',
        link: 'cottages/lake-view-lodges-no-3-lake-view-lodge-25074',
        id: '25074',
        property: true,
    },
    {
        name: 'Lake View Lodges - No. 5 Lake View Lodge',
        subtitle: '25076, Old Leake, near Boston, Lincolnshire',
        link: 'cottages/lake-view-lodges-no-5-lake-view-lodge-25076',
        id: '25076',
        property: true,
    },
    {
        name: 'Horselake Farm Cottages - Bramley',
        subtitle: '26767, Cheriton Bishop, Devon',
        link: 'cottages/horselake-farm-cottages-bramley-26767',
        id: '26767',
        property: true,
    },
    {
        name: 'Horselake Farm Cottages - Discovery',
        subtitle: '26768, Cheriton Bishop, Devon',
        link: 'cottages/horselake-farm-cottages-discovery-26768',
        id: '26768',
        property: true,
    },
];
//# sourceMappingURL=autocomplete.mock.js.map